<template>
  <div class="base-report report-cash-note">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.method" size="mini" >
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          height="100%"
          :summary-method="getSummaries">
          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && searchForm.method === methodType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

export default {
  name: 'ReportCashNote',
  data () {
    const methodType = {
      daily: 1,
      monthly: 2,
    }
    return {
      rounding: null,
      isLoading: false,
      noData: false,
      methodType: {...methodType},
      methods: [{value: methodType.daily, label: '日毎'}, {value: methodType.monthly, label: '月毎'}],
      staticSetting: [
        {label: '年月日', prop: 'date', align: 'center', fixed: true, sortable: true, width: '130px'},
        {label: '開始レジ金額', prop: 'openCashInRegister', align: 'right', sortable: true, width: '130px'},
        {label: '現金', prop: 'cashValuePrice', align: 'right', sortable: true, width: '130px'},
        {label: '理論レジ金額', prop: 'cashRemain', align: 'right', sortable: true, width: '130px'},
        {label: 'レジ金額', prop: 'cashInRegister', align: 'right', sortable: true, width: '130px'},
        {label: '過不足調整', prop: 'cashOverAndShort', align: 'right', sortable: true, width: '130px'},
        {label: '繰越金額', prop: 'balanceCarriedForward', align: 'right', sortable: true, width: '130px'},
        {label: '銀行入金', prop: 'bankDeposit', align: 'right', sortable: true, width: '130px'},
        {label: '万券', prop: 'man', align: 'right', sortable: true, width: '130px'},
        {label: '印紙', prop: 'stampTax', align: 'right', sortable: true, width: '130px'},
        {label: '金種'},
        [
          {label: '10,000円', prop: 'cash_10000', sortable: true, width: '120px'},
          {label: '5,000円', prop: 'cash_5000', sortable: true, width: '120px'},
          {label: '2,000円', prop: 'cash_2000', sortable: true, width: '120px'},
          {label: '1,000円', prop: 'cash_1000', sortable: true, width: '120px'},
          {label: '500円', prop: 'cash_500', sortable: true, width: '120px'},
          {label: '100円', prop: 'cash_100', sortable: true, width: '120px'},
          {label: '50円', prop: 'cash_50', sortable: true, width: '120px'},
          {label: '10円', prop: 'cash_10', sortable: true, width: '120px'},
          {label: '5円', prop: 'cash_5', sortable: true, width: '120px'},
          {label: '1円', prop: 'cash_1', sortable: true, width: '120px'},
        ],
      ],
      tableSetting: [],
      paidInIndex: 3,
      paidOutIndex: 4,
      searchForm: {
        method: methodType.daily,
        from_date: null,
        to_date: null,
      },
      currentMethod: methodType.daily,
      appendHeaders: {
        paidIn: [],
        paidOut: [],
      },
      orgData: [],
      orgTotalData: {},
      totalData: [],
      csv_filename: '現金管理表.csv',
    }
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
    ...mapGetters('report', ['roundingFunction']),
    screenData: function () {
      let result = []
      for (let data of this.orgData) {
        if (data.paid) {
          for (let paid of data.paid) {
            switch (paid['paidinoutPaidInoutStatus']) {
              case 0:
                data[`paidIn_${paid.paidinoutPaidInoutId}`] = paid.paidInout
                break
              case 1:
                data[`paidOut_${paid.paidinoutPaidInoutId}`] = paid.paidInout
                break
              default:
                break
            }
          }

          if (data.date === '合計') {
            this.orgTotalData = data
            continue
          }

          result.push(data)
        }
      }
      return result
    },
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.orgTotalData = {}
      this.orgData = []
      this.appendHeaders.paidIn = []
      this.appendHeaders.paidOut = []
      this.currentMethod = this.searchForm.method
      this.items = {}

      this.$request.reports.cashNotes(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method).then(res => {
        this.items = res.body

        this.updateScreenData()
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    updateScreenData () {
      if (this.items.headers) {
        let paidHeader = this.items.headers.paid
        for (let header of paidHeader) {
          switch (header['paidinoutPaidInoutStatus']) {
            case 0:
              this.appendHeaders.paidIn.push({
                id: header['paidinoutPaidInoutId'],
                name: header['paidinoutPaidInoutName'],
              })
              break
            case 1:
              this.appendHeaders.paidOut.push({
                id: header['paidinoutPaidInoutId'],
                name: header['paidinoutPaidInoutName'],
              })
              break
            default:
              break
          }
        }
        this.updateTableSetting()
      }
      if (this.items.records) {
        for (const record of this.items.records) {
          this.orgData.push(record)
        }
      }
    },
    updateTableSetting () {
      this.tableSetting = []
      this.tableSetting.push(...this.staticSetting)
      this.tableSetting[0].label = this.getDateStr()
      let paidIns = this.appendHeaders.paidIn
      let paidOuts = this.appendHeaders.paidOut
      let outsOffset = 0

      if (paidIns.length > 0) {
        let appendPaidIn = []
        for (let paidIn of paidIns) {
          let setting = {}
          setting.label = paidIn.name
          setting.prop = `paidIn_${paidIn.id}`
          setting.sortable = true
          appendPaidIn.push(setting)
        }
        this.tableSetting.splice(this.paidInIndex, 0, appendPaidIn)
        this.tableSetting.splice(this.paidInIndex, 0, {label: 'レジ入金'})
        outsOffset++
      }

      if (paidOuts.length > 0) {
        let appendPaidOut = []
        for (let paidOut of paidOuts) {
          let setting = {}
          setting.label = paidOut.name
          setting.prop = `paidOut_${paidOut.id}`
          setting.sortable = true
          appendPaidOut.push(setting)
        }
        this.tableSetting.splice(this.paidOutIndex + outsOffset, 0, appendPaidOut)
        this.tableSetting.splice(this.paidOutIndex + outsOffset, 0, {label: 'レジ出金'})
      }
    },
    getSummaries ({columns, data}) {
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let prop = columns[index].property
        this.totalData[index] = this.formatData(prop, this.orgTotalData[prop])
      })

      return this.totalData
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          // check padding
          if (!preHeader) {
            continue
          }
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      switch (this.currentMethod) {
        case this.methodType.daily:
          let date = moment(value, 'YYYY-MM-DD').format('YYYY/MM/DD')
          let day = moment(value, 'YYYY-MM-DD').locale('ja').format('ddd')
          result = date + '(' + day + ')'
          break
        case this.methodType.monthly:
          result = moment(value, 'YYYY-MM-DD').format('YYYY年MM月')
          break
      }
      return result
    },
    getDateStr () {
      switch (this.currentMethod) {
        case this.methodType.daily:
        default:
          return '年月日'
        case this.methodType.monthly:
          return '年月'
      }
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      let result = !isNaN(value) ? value : 0

      switch (key) {
        case 'date':
          return this.date(value)
        case 'openCashInRegister':
          return addFigure(this.rounding(value))
        case 'cashValuePrice':
          return addFigure(this.rounding(value))
        case 'cashRemain':
          return addFigure(this.rounding(value))
        case 'cashInRegister':
          return addFigure(this.rounding(value))
        case 'cashOverAndShort':
          return addFigure(this.rounding(value))
        case 'balanceCarriedForward':
          return addFigure(this.rounding(value))
        case 'bankDeposit':
          return addFigure(this.rounding(value))
        case 'stampTax':
          return addFigure(this.rounding(value))
        case 'cash_10000':
          return addFigure(this.rounding(value))
        case 'cash_5000':
          return addFigure(this.rounding(value))
        case 'cash_2000':
          return addFigure(this.rounding(value))
        case 'cash_1000':
          return addFigure(this.rounding(value))
        case 'cash_500':
          return addFigure(this.rounding(value))
        case 'cash_100':
          return addFigure(this.rounding(value))
        case 'cash_50':
          return addFigure(this.rounding(value))
        case 'cash_10':
          return addFigure(this.rounding(value))
        case 'cash_5':
          return addFigure(this.rounding(value))
        case 'cash_1':
          return addFigure(this.rounding(value))
        default:
          break
      }

      if (key.match(/^paidOut_\d+$/g) || key.match(/^paidIn_\d+$/g)) {
        result = addFigure(Math.abs(parseFloat(result)))
      }
      return result
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
  },
  created () {
    this.rounding = this.roundingFunction
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
//    this.fetchData()
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportCashNote.vue